const getters = {   //实时监听state值的变化(最新状态)
  language: state => state.app.language, // 中英文
  menuTitle: state => state.app.menuTitle, // 当前页面标题
  menuHighLight: state => state.app.menuHighLight, // 当前菜单key
  token: state => state.app.token, // 用户token
  account: state => state.app.account, // 用户account
  areaList: state => state.app.areaList, // 地区
  provinceList: state => state.app.provinceList, // 省份
  cityList: state => state.app.cityList, // 城市
  resellerList: state => state.app.resellerList, // 客户
  KeyDoorList: state => state.app.KeyDoorList, // iskeydoor
  courseClassList: state => state.app.courseClassList, // 品类
  roleList: state => state.app.roleList, // 角色
  statusList: state => state.app.statusList, // 状态
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js